import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateAttendanceController from "../../../../Controllers/Admin/Attendance/CreateAttendanceController";
import GetStudentsOfClass from "../../../../Controllers/Users/GetStudentsOfClass";
import HelperForMetaData from "../../../../Helpers/HelperForMetaData";
import StudentAbsentNotification from "../../../../Controllers/notifications/StudentAbsentNotification";
import StudentAbsentMailToParent from "../../../../Controllers/mails/StudentAbsentMailToParent";

export default function AddAttendanceViewModel() {
  const location = useLocation();
  const navigate = useNavigate();
  const [AuthUser, setAuthUser] = useState();

  const [FormDisabled, setFormDisabled] = useState(false);
  const [ClassID, setClassID] = useState("");
  const [CourseID, setCourseID] = useState("");
  const [StudentsArray, setStudentsArray] = useState("");
  const [IsAttendanceStart, setIsAttendanceStart] = useState(false);
  const [CheckAllStatus, setCheckAllStatus] = useState("");

  const [Students, setStudents] = useState([]);

  let SchoolID = localStorage.getItem("schoolId");

  SchoolID = JSON.parse(SchoolID);

  useEffect(() => {
    setCourseID(location.pathname.split("/").pop());
    setClassID(location.pathname.split("/").slice(-2, -1)[0]);
  }, [location.pathname]);

  const [AttendanceDetails, setAttendanceDetails] = useState({
    AttendanceDate: new Date(),
  });

  useEffect(() => {
    async function fetchData() {
      const studentsArray = await GetStudentsOfClass(ClassID);
      setStudentsArray(studentsArray);
    }
    fetchData();
  }, [ClassID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        setAuthUser(user);
      });
    }
    fetchData();
  }, []);

  const MarkAllStudentsAsPresent = () => {
    setCheckAllStatus("AllPresent");
    if (IsAttendanceStart === false) {
      setIsAttendanceStart(true);
    }
    let temp = [];
    StudentsArray.map((item, index) => {
      return temp.push({ id: item?.id, IsPresent: true });
    });
    setStudents([...temp]);
  };

  const MarkAllStudentsAsAbsent = () => {
    setCheckAllStatus("AllAbsent");
    if (IsAttendanceStart === false) {
      setIsAttendanceStart(true);
    }
    let temp = [];
    StudentsArray.map((item, index) => {
      return temp.push({ id: item?.id, IsPresent: false });
    });

    setStudents([...temp]);
  };

  const MarkStudentPresent = (id) => {
    if (IsAttendanceStart === false) {
      setIsAttendanceStart(true);
    }
    let temp = [...Students];
    let i;
    let student = temp.find((std, index) => {
      if (std.id === id) {
        i = index;
        return true;
      }
    });

    if (student) {
      temp[i].IsPresent = true;

      setStudents([...temp]);
    } else {
      setStudents([
        ...Students,
        {
          id: id,
          IsPresent: true,
        },
      ]);
    }
  };
  const MarkStudentAbsent = (id) => {
    if (IsAttendanceStart === false) {
      setIsAttendanceStart(true);
    }
    let temp = [...Students];
    let i;
    let student = temp.find((std, index) => {
      if (std.id === id) {
        i = index;
        return true;
      }
    });

    if (student) {
      temp[i].IsPresent = false;

      setStudents([...temp]);
    } else {
      setStudents([
        ...Students,
        {
          id: id,
          IsPresent: false,
        },
      ]);
    }
  };

  const CheckIsAbsent = (item) => {
    if (IsAttendanceStart) {
      let resp = Students.find((std) => {
        if (std.id === item.id) {
          return std;
        }
      });

      if (resp) {
        if (resp?.IsPresent) {
          return false;
        } else {
          return true;
        }
      }
    }
  };

  const CheckIsPresent = (item) => {
    if (IsAttendanceStart) {
      let resp = Students.find((std) => {
        if (std.id === item.id) {
          return std;
        }
      });
      if (resp) {
        if (resp?.IsPresent) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const CreateAttendance = async () => {
    setFormDisabled(true);

    const AttendanceObject = {
      ClassID,
      CourseID,
      SchoolID,
      ...AttendanceDetails,
      Students: Students,
      ...HelperForMetaData,
    };

    await CreateAttendanceController(AttendanceObject, AuthUser.uid)
      .then(() => {
        StudentAbsentNotification(AttendanceObject);
        StudentAbsentMailToParent(AttendanceObject);
        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return {
    ClassID,
    CourseID,
    StudentsArray,
    Students,
    setStudents,
    CreateAttendance,
    FormDisabled,
    AttendanceDetails,
    setAttendanceDetails,
    MarkStudentPresent,
    MarkStudentAbsent,
    CheckIsAbsent,
    CheckIsPresent,
    MarkAllStudentsAsPresent,
    MarkAllStudentsAsAbsent,
    CheckAllStatus,
    setCheckAllStatus,
  };
}
